export default "__VITE_PUBLIC_ASSET__7a0c11a2__"